import { render, staticRenderFns } from "./BuildingSocietyFormFiles.vue?vue&type=template&id=d801e8d6&scoped=true&"
import script from "./BuildingSocietyFormFiles.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyFormFiles.vue?vue&type=style&index=0&id=d801e8d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d801e8d6",
  null
  
)

export default component.exports